import {
    TotalEmissionsReportSettings,
    useFiltersApi,
    useFiltersStore,
} from '@/hooks'
import { SustainabilityFiltersValues } from '@/utils/constants'
import { useMemo } from 'react'
import { mapSustainabilityFiltersGetParams } from '../utils/mapSustainabilityFiltersGetParams'

export const useSustainabilityFiltersGetParams = (
    activeSustainabilityFilters: SustainabilityFiltersValues,
    reportSettings: TotalEmissionsReportSettings
) => {
    const rootNode = useFiltersStore((state) => state.rootNode)

    const { useCommoditiesQuery } = useFiltersApi()
    const { data: commodities } = useCommoditiesQuery({
        'nodeIds[]': rootNode?.nodeId.toString(),
    })

    const sustainabilityFiltersParams = useMemo(() => {
        const passedFilters = Object.assign({}, activeSustainabilityFilters)
        const { type, scope, scope2type } = reportSettings

        if (!passedFilters.node.length && rootNode) {
            passedFilters.node = [rootNode.nodeId]
        }

        if (!passedFilters.commodity.length && commodities) {
            passedFilters.commodity = commodities.map(
                (commodity) => commodity.commodityTypeId
            )
        }

        const params = mapSustainabilityFiltersGetParams(passedFilters)

        return {
            'nodeIds[]': params['nodeIds[]'] ?? '',
            ...params,
            type,
            scope,
            scope2type,
        }
    }, [activeSustainabilityFilters, commodities, reportSettings, rootNode])

    return sustainabilityFiltersParams
}
